// extracted by mini-css-extract-plugin
export default {"RankingSection":"styles_RankingSection__WHTuS","title":"styles_title__JmD0k","subTitle":"styles_subTitle__wC3ov","rankingContent":"styles_rankingContent__lcMSg"};